import { useMemo } from 'react';
import { find, get } from 'lodash';
import useAssetGroupSelector from './useAssetGroupSelector';
export default function useAssetGroupName(organisationGroupId, assetGroupId) {
    const { assetGroups } = useAssetGroupSelector(organisationGroupId);
    return useMemo(() => get(find(assetGroups, { id: assetGroupId }), 'name', 'Asset Category'), [assetGroups, assetGroupId]);
}
